import { useEffect } from 'react';
import { CaptionText, H1, H2, H3, P2 } from '../../../styles/FontStyles';
import { GrayBoxWrapper2, Main, Section2Wrapper } from '../Home.styled';

import { CheckIcon, PricingPill } from '../../../styles/svg';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Button } from 'components/Button/Button';
import { Div, Separator } from '../../../styles/Styles';

import Spinner from 'components/Spinner/Spinner';
import { addToCartLS } from 'helpers/localstorage-helper';
import { useNavigate } from 'react-router-dom';
import { DASHBOARD_CART } from 'routes/routes';
import { getPackages } from 'services/auth/packages.service';
import { PackagesModel } from '../Packages/Packages.types';
import { decodeJwt } from 'helpers/helpers';
import { ErrorToast } from 'components/Toasts/Toasts';
import { colors } from 'styles';

export const Section6 = () => {
  const dispatch = useAppDispatch();

  const token = useAppSelector((state) => state.authentication.tokens);

  const { loading, packages } = useAppSelector((state) => state.packages);

  const navigate = useNavigate();

  const addToCart = (selectedPackage: PackagesModel) => {
    if (token !== null) {
      const decodedToken = decodeJwt(token?.accessToken || '');
      if (!decodedToken.isRegistrationComplete) {
        ErrorToast('Complete your sign-up by filling in the remaining fields.');
        navigate('/auth/google-complete');
      } else {
        addToCartLS(selectedPackage);
        navigate(DASHBOARD_CART);
      }
    } else {
      addToCartLS(selectedPackage);
      navigate(DASHBOARD_CART);
    }
  };

  useEffect(() => {
    dispatch(getPackages());
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Spinner fullscreen={true} transparent />
      ) : (
        <Section2Wrapper id='section5'>
          <Main>
            <H2 center mb='24' mt='24' color={colors.primary}>
              Travelution App Subscription
            </H2>
            <H3 center mb='40' mt='24' color={colors.primary}>
              Travel like the elite, for the price of lunch.
            </H3>
            <GrayBoxWrapper2>
              {Array.isArray(packages) &&
                packages?.map((item: any, i: number) => {
                  if (i < 2)
                    return (
                      <div key={i}>
                        <Div $width='40%' $widthSM='100%'>
                          <img src={item?.imageUrl} alt={item?.name} />
                        </Div>
                        <Div $width='60%' $widthSM='100%'>
                          <H3 mt='24' mb='20'>
                            {item.name}
                          </H3>
                          <P2 mb='20'>{item?.price} USDC</P2>
                          <Separator $m='20px 0' />
                          <Div $flex $column $gap='12px' $mb='24px'>
                            {item?.benefits.map((b: any, i: number) => (
                              <Div $flex $alignCenter $gap='12px' key={i}>
                                <Div $flex $flexNone>
                                  <CheckIcon />
                                </Div>

                                <CaptionText>{b}</CaptionText>
                              </Div>
                            ))}
                          </Div>
                          <Button onClick={() => addToCart(item)}>
                            {item.buttonText}
                          </Button>
                        </Div>
                      </div>
                    );
                })}
            </GrayBoxWrapper2>
          </Main>
        </Section2Wrapper>
      )}
    </>
  );
};
